module.exports = __webpack_public_path__ + "img/r14.8d935d6c.jpg";